<div class="astral-stack-l">
  <h5>{{ 'COMPANY.SETTINGS_SIE4' | translate }}</h5>
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <astral-toggle [control]="form.controls['includeOrganizationNo']"></astral-toggle>
    <astral-toggle [control]="form.controls['includeCompanyCode']"></astral-toggle>
    <astral-toggle [control]="form.controls['includeAccountingYearDescription']"></astral-toggle>
    <astral-toggle [control]="form.controls['includeClosingBalance']"></astral-toggle>
    <astral-toggle [control]="form.controls['includeVerificationNumber']"></astral-toggle>
    <astral-select [control]="form.controls['encodingName']" [itemsSource]="encodingNameSelection"></astral-select>
    <astral-toggle [control]="form.controls['replaceLocalCharacters']"></astral-toggle>
    <astral-select [control]="form.controls['dim1']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim2']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim3']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim4']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim5']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim6']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim7']" [itemsSource]="dimensionSelection"></astral-select>
    <astral-select [control]="form.controls['dim8']" [itemsSource]="dimensionSelection"></astral-select>
  </astral-layout-group>
</div>
